import { createFileRoute } from '@tanstack/react-router';
import { usePageTitle } from '../../../../lib/hooks';
import { PageHeader } from '../../../../components/layout/PageHeader';
import { PageSection } from '../../../../components/layout/PageSection';
import { useStaffActivityReport } from '../../../../features/reports/client';
import { Input } from '../../../../components/ui/FormField';
import { DataView } from "../../../../components/ui/DataView";

export const Route = createFileRoute('/_auth/reports/operational/staff-activity')({
  component: StaffActivityPage,
});

function StaffActivityPage() {
  usePageTitle('Staff Activity');
  const staffactivityreportQuery = useStaffActivityReport();
      const { data } = staffactivityreportQuery;
  return (
    
      <div>
        <PageHeader title="Staff Activity Report" className="mb-6" /><div className="mb-6 flex gap-4 items-center">
                  <Input type="date" className="w-auto" />
                  <span>to</span>
                  <Input type="date" className="w-auto" />
                  <Input type="text" placeholder="Search staff member..." className="flex-1" />
                </div>
        <DataView query={staffactivityreportQuery}>
        {(data) => (
          <>
            <div className="flex flex-col gap-6">
                  {data?.map((staff: any) => (
                    <PageSection key={staff.userId || staff.actorId} title={staff.name || staff.actorName || 'Staff Member'}>
                      {staff.fraudSignals?.length > 0 && (
                        <div className="bg-danger-bg border border-danger-500 text-danger-text px-4 py-3 rounded mb-4">
                          <strong>Warning:</strong> Suspicious patterns detected (e.g., multiple reversals).
                        </div>
                      )}
                      <ul className="space-y-3">
                        {(staff.actions || staff.activities || []).map((activity: any, idx: number) => (
                          <li key={activity.id || idx} className="flex justify-between items-center py-2 border-b last:border-0">
                            <span className="font-medium">{activity.type || activity.action}: {activity.count ?? 1}</span>
                            {activity.timestamp && (
                              <span className="text-sm text-text-muted">{new Date(activity.timestamp).toLocaleString()}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </PageSection>
                  ))}
                </div>
          </>
        )}
        </DataView>
      </div>

    );
}
